import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const REG_COLUMNS = [
  "Scheme Name",
  "Folio",
  "Start Date",
  "End Date",
  "Next Date",
  "Last Transaction Date",
  "Amount (₹)",
  "Debit Date",
  "Frequency",
  "ARN",
  "Actions",
];

export default function ManageSIPs() {
  const [txnType, setTxnType] = useState("sip"); // sip | stp | swp
  const [registrationData, setRegistrationData] = useState([]); // empty for "No data available"
  const [selectedSIP, setSelectedSIP] = useState(null);

  const grandTotal = registrationData.reduce((sum, row) => sum + (row.amount || 0), 0);

  const handleExportRecentXls = () => {
    // TODO: export Recent Systematic Transactions
  };

  const handleExportRegXls = () => {
    // TODO: export Systematic Registration Detail
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <h3 className="text-primary mb-2">Manage SIPs</h3>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">Manage SIPs</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Transaction Type */}
        <div className="mb-4">
          <div className="d-flex flex-wrap gap-3 align-items-center">
            {["sip", "stp", "swp"].map((key) => (
              <label key={key} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                <input
                  type="radio"
                  name="txnType"
                  value={key}
                  checked={txnType === key}
                  onChange={() => setTxnType(key)}
                  style={{ accentColor: TEAL, width: 18, height: 18 }}
                />
                <span style={{ fontSize: "15px", color: "#334155", fontWeight: "500", textTransform: "uppercase" }}>{key}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Recent Systematic Transactions */}
        <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="card-header d-flex justify-content-between align-items-center py-3 px-4 bg-white border-bottom">
            <h5 className="mb-0" style={{ color: "#0f172a", fontWeight: "600", fontSize: "1rem" }}>
              Recent Systematic Transactions
            </h5>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center gap-1"
              onClick={handleExportRecentXls}
              title="Export Excel"
              style={{  border: `1px solid ${TEAL}`, borderRadius: "8px", fontWeight: "600" }}
            >
              <i className="fa fa-file-excel" aria-hidden />
              XLS
              <i className="fa fa-download ms-1" style={{ fontSize: "0.7rem" }} aria-hidden />
            </button>
          </div>
          <div className="card-body p-0">
            {/* Placeholder or small table - can add rows when you have data */}
            <div className="p-4 text-center text-muted small">Recent transactions will appear here.</div>
          </div>
        </div>

        {/* Systematic Registration Detail */}
        <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="card-header d-flex justify-content-between align-items-center py-3 px-4 bg-white border-bottom">
            <h5 className="mb-0" style={{ color: "#0f172a", fontWeight: "600", fontSize: "1rem" }}>
              Systematic Registration Detail
            </h5>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center gap-1"
              onClick={handleExportRegXls}
              title="Export Excel"
              style={{  border: `1px solid ${TEAL}`, borderRadius: "8px", fontWeight: "600" }}
            >
              <i className="fa fa-file-excel" aria-hidden />
              XLS
              <i className="fa fa-download ms-1" style={{ fontSize: "0.7rem" }} aria-hidden />
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  {REG_COLUMNS.map((col) => (
                    <th key={col} style={{ padding: "12px 16px", color: "#475569", fontWeight: "600", fontSize: "13px", whiteSpace: "nowrap" }}>
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody style={{ background: "#fff" }}>
                {registrationData.length === 0 ? (
                  <tr>
                    <td colSpan={REG_COLUMNS.length} className="p-0 border-0" style={{ verticalAlign: "top" }}>
                      <div className="text-center py-5" style={{ color: "#64748b" }}>
                        <i className="fa fa-exclamation-triangle d-block mb-2" style={{ fontSize: "2rem", color: "#f59e0b" }} aria-hidden />
                        No data available.
                      </div>
                    </td>
                  </tr>
                ) : (
                  registrationData.map((row, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "12px 16px" }}>{row.schemeName}</td>
                      <td style={{ padding: "12px 16px" }}>{row.folio}</td>
                      <td style={{ padding: "12px 16px" }}>{row.startDate}</td>
                      <td style={{ padding: "12px 16px" }}>{row.endDate}</td>
                      <td style={{ padding: "12px 16px" }}>{row.nextDate}</td>
                      <td style={{ padding: "12px 16px" }}>{row.lastTxnDate}</td>
                      <td style={{ padding: "12px 16px" }}>{row.amount != null ? `₹ ${Number(row.amount).toLocaleString()}` : ""}</td>
                      <td style={{ padding: "12px 16px" }}>{row.debitDate}</td>
                      <td style={{ padding: "12px 16px" }}>{row.frequency}</td>
                      <td style={{ padding: "12px 16px" }}>{row.arn}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <button type="button" className="btn btn-sm btn-outline-primary me-1">View</button>
                        <button type="button" className="btn btn-sm btn-outline-secondary">Modify</button>
                      </td>
                    </tr>
                  ))
                )}
                {/* Grand Total row */}
                <tr style={{ background: TEAL, color: "#fff" }}>
                  <td colSpan={6} style={{ padding: "12px 16px", fontWeight: "600", fontSize: "14px" }}>
                    Grand Total :
                  </td>
                  <td style={{ padding: "12px 16px", fontWeight: "600", fontSize: "14px" }}>
                    {grandTotal.toLocaleString()}
                  </td>
                  <td colSpan={4} style={{ padding: "12px 16px" }} />
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* SIP Detail Modal */}
        {selectedSIP && (
          <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow" style={{ borderRadius: "12px" }}>
                <div className="modal-header border-0">
                  <h5 className="modal-title" style={{ fontWeight: "600" }}>SIP Details</h5>
                  <button type="button" className="btn-close" onClick={() => setSelectedSIP(null)} aria-label="Close" />
                </div>
                <div className="modal-body">
                  <p className="mb-2"><strong>SIP ID:</strong> {selectedSIP.id}</p>
                  <p className="mb-2"><strong>Fund:</strong> {selectedSIP.fund}</p>
                  <p className="mb-2"><strong>Amount:</strong> ₹ {selectedSIP.amount}</p>
                  <p className="mb-2"><strong>SIP Date:</strong> {selectedSIP.sipDate}th</p>
                  <p className="mb-0"><strong>Status:</strong> {selectedSIP.status}</p>
                  {selectedSIP.bounceReason && (
                    <p className="text-danger mt-2 mb-0"><strong>Bounce Reason:</strong> {selectedSIP.bounceReason}</p>
                  )}
                </div>
                <div className="modal-footer border-0">
                  <button type="button" className="btn btn-secondary" style={{ borderRadius: "8px" }} onClick={() => setSelectedSIP(null)}>Close</button>
                  <button type="button" className="btn text-white" style={{ background: TEAL, borderRadius: "8px" }}>Modify SIP</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}











// import React, { useState } from "react";
// import ClientNavbar from "../layout/ClientNavbar";
// import { NavLink } from "react-router-dom";

// export default function ManageSIPs() {
//   /* ------------------ STATIC SIP DATA ------------------ */
//   const sipData = [
//     {
//       id: "SIP001",
//       fund: "Axis Bluechip Fund",
//       amount: 5000,
//       sipDate: 10,
//       nextInstallment: "10 Feb 2026",
//       status: "Active",
//       bounceReason: null,
//     },
//     {
//       id: "SIP002",
//       fund: "HDFC Midcap Opportunities",
//       amount: 3000,
//       sipDate: 15,
//       nextInstallment: "15 Feb 2026",
//       status: "Paused",
//       bounceReason: null,
//     },
//     {
//       id: "SIP003",
//       fund: "ICICI Prudential Debt Fund",
//       amount: 2000,
//       sipDate: 5,
//       nextInstallment: "05 Feb 2026",
//       status: "Active",
//       bounceReason: "Insufficient balance",
//     },
//   ];

//   const [selectedSIP, setSelectedSIP] = useState(null);

//   return (
//     <>
//       <ClientNavbar />
//       <div className="page-content" style={{ background: "#f1f5f9" }}>
//           {/* Header */}
//           <div className="card shadow-sm p-4 mb-4">
//                 {/* <div className="card shadow-sm p-4 mb-4"> */}
//             <h3 className="text-primary mb-2">Manage SIPs</h3>

//             {/* Breadcrumb with custom link color */}
//             <nav
//               aria-label="breadcrumb"
//               style={{ "--bs-breadcrumb-divider": "none" }}
//             >
//               <ol className="breadcrumb">
//                 <li className="breadcrumb-item">
//                   <NavLink to="/overview">Dashboard</NavLink> /
//                 </li>
//                 <li className="breadcrumb-item">
//                   <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
//                 </li>
//                 <li className="breadcrumb-item active" aria-current="page">
//                   Manage SIPs
//                 </li>
//               </ol>
//             </nav>
//             </div>
//             {/* </div> */}

//             {/* SIP List */}
//             <div className="card shadow-sm">
//               <table className="table table-hover mb-0 sip-table">
//                 <thead className="table-light">
//                   <tr>
//                     <th>SIP ID</th>
//                     <th>Fund</th>
//                     <th>Amount</th>
//                     <th>SIP Date</th>
//                     <th>Next Installment</th>
//                     <th>Status</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {sipData.map((sip) => (
//                     <tr key={sip.id}>
//                       <td data-label="SIP ID">{sip.id}</td>
//                       <td data-label="Fund">{sip.fund}</td>
//                       <td data-label="Amount">₹ {sip.amount}</td>
//                       <td data-label="SIP Date">{sip.sipDate}th</td>
//                       <td data-label="Next Installment">
//                         {sip.nextInstallment}
//                       </td>
//                       <td data-label="Status">
//                         <span
//                           className={`badge ${
//                             sip.status === "Active"
//                               ? "bg-success"
//                               : sip.status === "Paused"
//                                 ? "bg-warning text-dark"
//                                 : "bg-danger"
//                           }`}
//                         >
//                           {sip.status}
//                         </span>

//                         {sip.bounceReason && (
//                           <div className="text-danger small mt-1">
//                             ⚠ {sip.bounceReason}
//                           </div>
//                         )}
//                       </td>
//                       <td data-label="Action">
//                         <button
//                           className="btn btn-sm btn-outline-primary me-2"
//                           onClick={() => setSelectedSIP(sip)}
//                         >
//                           View
//                         </button>

//                         {sip.status === "Active" && (
//                           <button className="btn btn-sm btn-outline-warning me-2">
//                             Pause
//                           </button>
//                         )}

//                         {sip.status === "Paused" && (
//                           <button className="btn btn-sm btn-outline-success me-2">
//                             Resume
//                           </button>
//                         )}

//                         <button className="btn btn-sm btn-outline-danger">
//                           Cancel
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//         {/* SIP Detail Modal */}
//         {selectedSIP && (
//           <div
//             className="modal fade show d-block"
//             style={{ background: "#0008" }}
//           >
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h5 className="modal-title">SIP Details</h5>
//                   <button
//                     className="btn-close"
//                     onClick={() => setSelectedSIP(null)}
//                   />
//                 </div>

//                 <div className="modal-body">
//                   <p>
//                     <strong>SIP ID:</strong> {selectedSIP.id}
//                   </p>
//                   <p>
//                     <strong>Fund:</strong> {selectedSIP.fund}
//                   </p>
//                   <p>
//                     <strong>Amount:</strong> ₹ {selectedSIP.amount}
//                   </p>
//                   <p>
//                     <strong>SIP Date:</strong> {selectedSIP.sipDate}th
//                   </p>
//                   <p>
//                     <strong>Status:</strong> {selectedSIP.status}
//                   </p>
//                   {selectedSIP.bounceReason && (
//                     <p className="text-danger">
//                       <strong>Bounce Reason:</strong> {selectedSIP.bounceReason}
//                     </p>
//                   )}
//                 </div>

//                 <div className="modal-footer">
//                   <button
//                     className="btn btn-secondary"
//                     onClick={() => setSelectedSIP(null)}
//                   >
//                     Close
//                   </button>
//                   <button className="btn btn-outline-primary">
//                     Modify SIP
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }
